import fp from 'lodash/fp';
import { put, takeLatest, call, all } from 'redux-saga/effects';
import { rawRequest, contentTypeJson } from '@factorin/rest';

import { wrapRequest } from 'Modules/core/api';

import { infoActions } from './actions';


function* sendRequest(url) {
    const result = yield call(wrapRequest, rawRequest, {
        method: 'GET',
        url,
        headers: {
            Accept: contentTypeJson,
            'Accept-Language': 'ru',
            'Content-Type': contentTypeJson,
            'Cache-Control': 'no-cache, no-store, must-revalidate',
        },
    });
    return result;
}

function* getInfo({ $payload: { lang, staticUrl } }) {
    const [about, history] = yield all([
        sendRequest(`${staticUrl}/content/json/about_${lang}.json`),
        sendRequest(`${staticUrl}/content/json/history_${lang}.json`),
    ]);

    yield put(infoActions.set({
        lang,
        data: {
            about: {
                Date: about.Date,
                Values: fp.chunk(3, about.Values),
            },
            history,
        },
    }));
}

export const sagas = [
    takeLatest(`${infoActions.get}`, getInfo),
];
